import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Link, useNavigate } from "react-router-dom"
import { Form, Button, Alert } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { login } from "../../data/authenticationSlice"
import { validEmailRegex } from "../../constant/utils"
import Loader from "../../components/Loader"
import { css } from "@emotion/react"

const componentStyles = css`
    .custom-alert {
        padding: 6px 12px;
        font-size: 14px;
        line-height: 1.5;
    }
`

const Login = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const location = useLocation()
    let { message } = location.state || {}
    const sessionOut = window.sessionStorage.getItem("sessionOut")
    if (sessionOut) {
        message = "Your session has expired. Please login again."
    }

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    })
    const [errors, setErrors] = useState({ firstName: null, email: null })
    const { isAuthenticated, fetchStatus } = useSelector((state) => state.authentication)

    useEffect(() => {
        const site = location.pathname.split("/")[1]

        if (isAuthenticated) {
            navigate(`/${site}`)
        }
    }, [isAuthenticated])

    const handleChange = (event) => {
        const { name, value, checked, type } = event.target
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        })
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        window.sessionStorage.removeItem("sessionOut")
        const site = location.pathname.split("/")[1]

        formData.email = formData.email.trim()
        let payload = {
            ...formData,
            returnUrl: "string",
            site: site === "agency" ? "broker" : site
        }
        if (!formData?.email || !validEmailRegex.test(formData?.email) || !formData?.password) {
            setErrors({
                email: !formData?.email || !validEmailRegex.test(formData?.email) ? "Please enter a valid email" : "",
                password: !formData?.password ? "Please enter your password" : ""
            })
            return false
        }
        dispatch(login(payload)).then(({ payload }) => {
            if (payload?.succeeded) {
                window.sessionStorage.setItem("ACCESS_TOKEN", payload?.token)
                window.sessionStorage.setItem("site", site)
                if (payload?.refreshToken) {
                    window.sessionStorage.setItem("REFRESH_TOKEN", payload?.refreshToken)
                    site === "admin" ? navigate(`/${site}/applications`) : navigate(`/${site}/dashboard`)
                } else {
                    navigate(`/${site}/login-mfa`)
                }
            } else if (!payload?.succeeded && payload?.errorMessage) {
                setErrors({
                    errorMessage: payload?.errorMessage
                })
            }
        })
    }

    return (
        <div
            css={componentStyles}
            className=" container d-flex flex-column justify-content-center align-items-center vh-100">
            <Loader show={fetchStatus === "loading"} />
            <div className="col-md-4 auth-box bg-white">
                <h1 className="text-center mb-4">Login</h1>
                {!!message && (
                    <Alert
                        variant="info"
                        className="custom-alert">
                        {message}
                    </Alert>
                )}
                <Form onSubmit={handleSubmit}>
                    <Form.Group controlId="formEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="text"
                            name="email"
                            className="form-control-sm"
                            value={formData.email}
                            onChange={handleChange}
                            placeholder="Enter your email"
                            autoComplete="email"
                        />
                        {errors?.email && <Form.Text className="text-danger">{errors?.email}</Form.Text>}
                    </Form.Group>

                    <Form.Group
                        controlId="formPassword"
                        className="mt-2">
                        <Form.Label>Password</Form.Label>
                        <Form.Control
                            type="password"
                            name="password"
                            className="form-control-sm"
                            value={formData.password}
                            onChange={handleChange}
                            placeholder="Enter your password"
                            autoComplete="current-password"
                        />
                        {errors?.password && <Form.Text className="text-danger">{errors?.password}</Form.Text>}
                    </Form.Group>
                    {errors?.errorMessage && <Form.Text className="text-danger">{errors?.errorMessage}</Form.Text>}
                    <div className="d-grid mt-4">
                        <Button
                            className="btn-sm"
                            type="submit"
                            variant="primary">
                            Login
                        </Button>
                    </div>
                </Form>

                <div className="text-center mt-3">
                    <Link to="/forgot-password">Forgot password ?</Link>
                </div>
            </div>
        </div>
    )
}

export default Login
